<template>
    <div class="annualPlan">
        <div class="wx_title"><span>年计划</span></div>
        <div class="select_year">
            <span class="label">选择年份:</span>
            <el-date-picker
                    v-model="year"
                    type="year"
                    format="yyyy 年"
					value-format="yyyy"
                    size="mini"
                    placeholder="选择年" @change="getFarmYearTask">
            </el-date-picker>
        </div>
        <div class="tabs">
			<span :class="{'active':tabShowNum==0}" @click="clickPartition(0)">所有分区</span>
			 
            <span :class="{'active':tabShowNum==item.id}" @click="clickPartition(item.id,item.number)" v-for="(item,index) in partition_list">{{item.name}}</span>
                   
        </div>
        <div class="content">
            <h3 class="title"  v-if="partition_id>0 && isActive==1 && (user_position_code==150 || user_position_code==200)">
                <span>{{partition_crop_name}}</span>
                <span style="display: none;">春见</span>
                <div class="top_btn" >
                    <el-button @click="onekeyShow = true">一键年计划</el-button>
                    <el-button @click="importTask()">导入历史年计划</el-button>
                </div>
            </h3>
            <div class="steps"  v-if="show==true ">
                <div class="step" :class="{'active':isActive == 1}" @click="isActive=1">年计划任务</div>
                <img :src="isActive == 1?stepImg:isStepImg" alt="">
                <div class="step" :class="{'active':isActive == 2}" @click="isActive=2">年预算</div>
            </div>
            <template v-if="isActive == 1">
                <div class="tabTop">
                    <div class="select_box">
                        <el-select v-model="allYears" placeholder="所有年份" size="medium" style="display: none;">
                            <el-option
                                    v-for="item in allYearsList"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select v-model="tabPage.type_id" placeholder="任务类别" size="medium" @change="changeTaskType" clearable="">
                            <el-option
                                    v-for="item in typeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="btn_box" v-if="partition_id>0 && isActive==1 && publish_count==0 && (user_position_code==150 || user_position_code==200)">
                        <el-button @click="emptyShow = true">清空</el-button>
                        <el-button @click="addTaskShow = true" v-if="show==true">添加任务</el-button>
                    </div>
                </div>
                <el-table :data="taskTableData" class="wx_table" :row-class-name="tableRowClassName">
                    <el-table-column prop="display_run_time" label="执行日期"></el-table-column>
                    <el-table-column prop="type_name" label="任务类别"></el-table-column>
					<!-- <el-table-column prop="is_publish" label="状态" style="display: none;">
						<template slot-scope="scopes">
							 <span v-if="scopes.row.is_publish==1">已发布</span>
							 <span v-else>未发布</span>
						</template>
						
					</el-table-column> -->
                    <el-table-column prop="task_name" label="任务名"></el-table-column>			
                    <el-table-column prop="task_remark" label="任务操作说明"></el-table-column>
                   
				<el-table-column label="操作" prop="id" >
				    <template slot-scope="scope">
						<span v-if="scope.row.is_publish==1 && (user_position_code==150 || user_position_code==200)">
							<el-button class="del_btn" type="danger" @click='jump(scope.row.id)'>详情</el-button>
						</span>
						<span v-else-if="scope.row.is_publish==2 && (user_position_code==150 || user_position_code==200)">
							<el-button class="edit_btn" type="primary" plain size="small" @click="editPlan(scope.row.id)" >编辑{{user_position_code}}</el-button>
							<el-button class="del_btn" type="danger" plain size="small" @click="deletePlan(scope.row.id)" >删除</el-button>
							
						</span>
						<span v-else>
				<el-button class="del_btn" type="danger" @click='jump(scope.row.id)'>详情</el-button>
						</span>
				    </template>
				
				</el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tabPage.currentPage" :page-sizes="[5, 10, 20, 40]" :page-size="tabPage.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div>
                <div class="bottom_btn">
                    <el-button @click="releaseShow = true"  v-if="partition_id>0 && publish_count==0 && (user_position_code==150 || user_position_code==200)">发布</el-button>
                </div>
            </template>
            <template v-if="isActive == 2">
                <div class="tabTitle">预计投入:</div>
                <el-table :data="fee_list" class="wx_table" :row-class-name="tableRowClassName" show-summary>
                    <el-table-column prop="label" label="费用名称"></el-table-column>
                    <el-table-column prop="number" label="预计金额 (万元)"></el-table-column>
                    <el-table-column label="操作" v-if="partition_id>0">
                        <template slot-scope="scope">
                            <el-button class="edit_btn" type="primary" plain size="small" v-if="scope.row.is_edit & count==0" @click="editBudget(scope.row.value,'万元')">编辑</el-button>
                            <span v-else>————</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="tabTitle marTop" v-if="partition_id>0">预估产值({{number}}株):</div>
                <el-table :data="est_list" class="wx_table" :row-class-name="tableRowClassName" show-summary :summary-method="getSummary" v-if="partition_id>0">
                    <el-table-column prop="label" label="名称"></el-table-column>
					 <el-table-column prop="number" label="数量"></el-table-column>
                    <el-table-column prop="unit" label="单位">
                      
                    </el-table-column>
                    <el-table-column label="操作" >
                        <template slot-scope="scope">
                            <el-button class="edit_btn" type="primary" plain size="small" v-if="scope.row.is_edit==1 && count==0" @click="editBudget(scope.row.value,scope.row.unit)">编辑</el-button>
                            <span v-else>————</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="bottom_btn">
                 
                <el-button @click="releaseConfirmShow = true"  v-if="partition_id>0 && publish_budget_count==0">发布预算</el-button>
				</div>
            </template>
        </div>
        <!--弹窗-->
        <!--清空-->
        <WxMessageBox :show="emptyShow" @save="emptySave" @canse="emptyCanse">
            <div slot="content">
                <div class="word">
                    <p>您确定要清空当前年计划任务嘛？</p>
                </div>
            </div>
        </WxMessageBox>
        <!--发布-->
        <WxMessageBox :show="releaseShow" @save="releaseSave" @canse="releaseCanse">
            <div slot="content">
                <div class="word marTop">
                    <p>您确定发布此年计划，发布之后，</p>
                    <p>将无法更改！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--发布点击确认判断弹窗-->
        <WxMessageBox :show="releaseConfirmShow" @save="releaseConfirmSave" @canse="releaseConfirmCanse">
            <div slot="content">
                <div class="word marTop">
                    <p>确定发布此{{year}}年此分区的年预算嘛？</p>
                    <p>发布之后,将无法更改！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--导入年计划-->
        <WxMessageBox :show="importShow" @save="importSave" @canse="importCanse">
            <div slot="content">
				<el-form :model="importForm" :rules="importRules" ref="importForm" label-width="0px">
                <div class="import">
                    <div class="label">导入:</div>
					
					<div class="item">
					    <span class="item_label">种类</span>
					    <div class="wx_radio">
							<el-form-item label="" prop="type">
					        <el-radio-group v-model="importForm.type" @change="changeType">
					            <el-radio :label="1">年计划任务</el-radio>
					           <!-- <el-radio :label="2">日常工作任务</el-radio> -->
					        </el-radio-group>
							</el-form-item>
					    </div>
					</div>
                    <div class="item">
                        <span class="item_label">年份</span>
                        <div class="input">
							<el-form-item label="" prop="year">
                            <el-select v-model="importForm.year" placeholder="请选择" size="mini" clearable="">
                                <el-option
                                        v-for="item in year_list"
                                        :key="item.year"
                                        :label="item.year"
                                        :value="item.year">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                    
                    
                </div>
				</el-form>
            </div>
        </WxMessageBox>
        <!--导入年计划判断，如果还没有历史记录！-->
        <WxMessageBox :show="importConfirmShow1" @save="importConfirmSave1" @canse="importConfirmCanse1">
            <div slot="content">
                <div class="word marTop">
                    <p>对不起，您还没有历史记录，</p>
                    <p>无法导入！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--判断，如果今年和明年的年计划都 有了，点击导入按钮时出现如上提示！导入和一键共用-->
        <WxMessageBox :show="importConfirmShow2" @save="importConfirmSave2" @canse="importConfirmCanse2">
            <div slot="content">
                <div class="word marTop">
                    <p>对不起，您的年计划已经建立，</p>
                    <p>等明年时再建吧！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--一键年计划-->
        <WxMessageBox :show="onekeyShow" @save="onekeySave" @canse="onekeyCanse" >
            <div slot="content" >
				<el-form :model="oneForm" :rules="oneRules" ref="oneForm" label-width="0px">
                <div class="import" >
                    <div class="item">
                        <span class="item_label">选择年份:</span>
                                               <div class="wx_radio">
												   <el-form-item label="" prop="type">
                                                   <el-radio-group v-model="oneForm.type" >
                                                       <el-radio :label="1">今年</el-radio>
                                                       
                                                   </el-radio-group>
												   </el-form-item>
                                               </div>
                    </div>
					
                    <div class="bottom_label">您是否确定通过系统规则，自动生成年计划 任务，生成之后，可以自行再次编辑和修改。</div>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
        <!--判断，一键年计划-->
        <WxMessageBox :show="onekeyConfirmShow" @save="onekeyConfirmSave" @canse="onekeyConfirmCanse">
            <div slot="content">
                <div class="word marTop">
                    <p>对不起，您的明年基础信息还没有，</p>
                    <p>请选去建立明年的农事和分区信息</p>
                    <button>前往农事信息</button>
                </div>
            </div>
        </WxMessageBox>
        <!--添加任务-->
        <WxMessageBox :show="addTaskShow" @save="addTaskSave" @canse="addTaskCanse">
            <div slot="content">
				<el-form :model="taskForm" :rules="taskRules" ref="taskForm" label-width="0px">
                <div class="import addTask">
                    <div class="item">
                        <span class="item_label">请选择任务类别;</span>
                        <div class="input">
							<el-form-item label="" prop="type_id">
                            <el-select v-model="taskForm.type_id" placeholder="请选择" size="mini" @change="changeAllTaskType">
                                <el-option
                                        v-for="item in typeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                    <div class="item">
                        <span class="item_label">请选择任务：</span>
                        <div class="input">
							<el-form-item label="" prop="data_task_id">
                            <el-select v-model="taskForm.data_task_id" placeholder="请选择" size="mini" filterable>
                                <el-option
                                        v-for="item in task_list"
                                        :key="item.id"
                                        :label="item.task_name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
							</el-form-item>
                        </div>
                    </div>
                    <div class="item">
                        <span class="item_label">请选择执行日期：</span>
                        <div class="input">
							<el-form-item label="" prop="display_run_time">
                            <el-date-picker
                                    v-model="taskForm.display_run_time"
                                    type="date"
                                    size="mini"
									value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                            </el-date-picker>
							</el-form-item>
                        </div>
                    </div>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
        <!--点击删除弹窗-->
        <WxMessageBox :show="delShow" @save="delSave" @canse="delCanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你是否确定删除此项，删除后，</p>
                    <p>将不可恢复！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--年预算编辑-->
        <WxMessageBox :show="editBudgetShow" @save="editBudgetSave" @canse="editBudgetCanse">
            <div slot="content">
				<el-form :model="budgetForm" :rules="budgetRules" ref="budgetForm" label-width="10px">
                <div class="edit_box">
                    <div class="form_item">
                        <span class="lable">请输入({{editUnit}})</span>
                        <div class="input">
							<el-form-item label="" prop="budget">
								<el-input-number v-model="budgetForm.budget"  :min="0"  label="描述文字"></el-input-number>
                       
							</el-form-item>
                        </div>
                        <div class="label_tips" style="display: none;">{{editUnit}}</div>
                    </div>
                </div>
				</el-form>
            </div>
        </WxMessageBox>
    </div>
</template>

<script>
	import {copyFarmYearTask,copyFarmWorkTask,getFarmYearTaskYears,getFarmWorkTaskYears,getFarmYearTask,makeFarmYearPlan,clearFarmYearTask,addFarmYearTask,getAllTask,deleteFarmTask,getFarmAreaBudget,submitFarmAreaBudget,publishFarmYearWork} from '@/api/api'
    import WxMessageBox from '@/components/MessageBox';
    export default {
        name: "annualPlan",
        data(){
            return{
				user_position_code:0,
				publish_count:0,
				task_count:0,
                year:new Date().getFullYear().toString(),
                tabShowNum:0,
                isActive:1,
                stepImg:require('../../../assets/images/allow_03.png'),
                isStepImg:require('../../../assets/images/allow_02.png'),
				show:true,
				partition_list:[],
				partition_crop_name:'',
				partition_id:0,
				total:0,
				typeList:[],
				tabPage:{
					type_id:'',
				    currentPage:1, // 初始页
				    pagesize:5,    // 每页的数据
				},
				number:0,
				taskTableData:[],
				task_list:[],
				taskForm:{ 
					       type_id:'',
						   data_task_id:'',
						   display_run_time:'',							  
				},
				taskRules: {
					type_id: [{required: true,message: '请选择任务类别',trigger: 'change'}],
				    data_task_id: [{required: true,message: '请选择任务',trigger: 'change'}],
					display_run_time: [{required: true,message: '请选择任务执行时间',trigger: 'change'}],															
				},
				
				editUnit:'',
				budget_value:'',
				  budgetForm:{
				  	       budget:'',						  
				  },
				  budgetRules: {
				  	 budget: [{required: true,message: '必填',trigger: 'blur'}],														
				  },
				fee_list:[],
				est_list:[],
				
				
                allYears:'',
                type:'',
                allYearsList:[{id:1,value:'2021年'}],
                
               year_list:[],
               importForm:{ 
               	       type:1,
               		   year:'',
               		  						  
               },
               importRules: {
               	type: [{required: true,message: '必选',trigger: 'change'}],
                year: [{required: true,message: '必选',trigger: 'change'}],												
               },
               
 oneForm:{ 
               	       type:1,
               		  
               		  						  
               },
               oneRules: {
               	type: [{required: true,message: '必选',trigger: 'change'}],
                												
               },
             
                emptyShow:false,
                releaseShow:false,
                releaseConfirmShow:false,
                importShow:false,
                importConfirmShow1:false,
                importConfirmShow2:false,
                onekeyShow:false,
                onekeyConfirmShow:false,
                addTaskShow:false,
                delShow:false,
                editBudgetShow:false,
                years:'',
                yearsOptions:[{id:1,value:'历史有记录的年份'}],
                radio_msg1:'',
                radio_msg2:'',
                radio_year:'',

              
                

            }
        },
		created() {
			  this.getFarmYearTask(this.year)
			   this.get_farm_area_budget()
		},
        methods:{
			changeType(val){
				if(val==1){
					getFarmYearTaskYears(this.$route.params.id,this.partition_id).then(resp=>{
						this.year_list=resp;
					})
				}else{
					getFarmWorkTaskYears(this.$route.params.id,this.partition_id).then(resp=>{
						this.year_list=resp;
					})
				}
			},
			importTask(){
				this.importShow=true
				
			},
			jump(id){
				console.log(id)
				this.$router.push("/park/farming/detaill/"+this.$route.params.id+"/"+id)
			},
			 getSummary(param) {
				 const { columns, data } = param;
				 const sums = [];
				   columns.forEach((column, index) => {
				           if (index === 0) {
				             sums[index] = '总价';
				             return;
				           }
						   
				           const values = data.map(item => Number(item[column.property]));
				           if (!values.every(value => isNaN(value))) {
				             sums[index] = values.reduce((prev, curr,index,arr) => {
				               const value = Number(curr);
							   console.log(value)
				               if (!isNaN(value)) {
				                 return arr[0]*arr[1]*this.number;
				               } else {
								  // console.log(prev+"cccc")
				                 return 0;
				               }
				             }, 0);
				             sums[index] += ' 元';
				           } else {
				             sums[index] = '';
				           }
				         });
				 
				         return sums;
				 },
			getFarmYearTask(val){
				getFarmYearTask(this.$route.params.id,this.partition_id,val,this.tabPage).then(resp=>{
					this.publish_count=resp.publish_count
					this.publish_budget_count=resp.publish_budget_count
					this.task_count=resp.task_count
					this.user_position_code=resp.position_code
					this.partition_list=resp.partition_list
					this.total=resp.list.total
					this.taskTableData=resp.list.data
					this.typeList=resp.type
					  if(this.partition_list.length==0){
						  this.show=false
						  }
				})
			},
			changeTaskType(){
				this.getFarmYearTask(this.year)
			},
			changeAllTaskType(val){
				console.log(val)
				  getAllTask(val).then(resp=>{
					  this.task_list=resp
				  })
			},
			//分区点击
			clickPartition(id,number){
				this.tabShowNum=id
				if(this.partition_list.length>0){
					this.show=true
				   this.partition_list.forEach((item,index)=>{
					    if(id==item['id']){
						//	this.partition_id=item.id
							this.partition_crop_name=item.crop.name+"("+item.crop.alias+")"
						} 
						
				   })
				   this.partition_id=id
				 //  this.partition_crop_name=''
				   this.number=number
					 this.get_farm_area_budget()
					this.getFarmYearTask(this.year)
				   
			}else{
				this.show=false
			}
			
			},
			
			get_farm_area_budget(){
				  getFarmAreaBudget(this.$route.params.id,this.partition_id,this.year).then(resp=>{
					   this.fee_list=resp.fee_table
					   this.est_list=resp.est_table
					   ///console.log(this.est_list)
					   this.count=resp.count
					  
				  })
			},
            // 表格斑马纹
            tableRowClassName({row, rowIndex}) {
                if (rowIndex % 2 !== 1) {
                    return 'single-row';
                }else{
                    return 'double-row';
                }
            },
            // 分页
            handleSizeChange: function (size) {
                this.tabPage.pagesize = size;
				this.getFarmYearTask(this.year)
                //console.log(this.pagesize)  //每页下拉显示数据
            },
            handleCurrentChange: function(currentPage){
                this.tabPage.currentPage = currentPage;
				this.getFarmYearTask(this.year)
                //console.log(this.currentPage)  //点击第几页
            },
            // 清空弹窗确认
            emptySave(){
				clearFarmYearTask(this.$route.params.id,this.partition_id,this.year).then(resp=>{
					this.getFarmYearTask(this.year)
					this.emptyShow = false
				})
                
            },
            // 清空弹窗取消
            emptyCanse(){
                this.emptyShow = false
            },
            // 发布弹窗确认
            releaseSave(){
				if(this.partition_id==0){
					this.$message.error("必须选择分区")
					return false
				}
				 publishFarmYearWork(this.$route.params.id,this.partition_id,this.year).then(resp=>{		
					 this.getFarmYearTask(this.year)
					 this.$message.success("发布成功")
					this.releaseShow = false
				 })
                
                /* this.$nextTick(()=>{
                    this.releaseConfirmShow = true
                }) */
            },
            // 发布弹窗取消
            releaseCanse(){
                this.releaseShow = false
            },
            // 发布点击确认弹窗确认
            releaseConfirmSave(){
				
				submitFarmAreaBudget(this.$route.params.id,this.partition_id,this.year,{est:this.est_list,fee:this.fee_list}).then(resp=>{
					this.get_farm_area_budget()
					 this.releaseConfirmShow = false
				})
               
            },
            // 发布点击确认弹窗取消
            releaseConfirmCanse(){
                this.releaseConfirmShow = false
            },
            // 导入年计划弹窗确认
            importSave(){
				this.$refs["importForm"].validate((valid) => {
					if (valid) {	
						if(this.importForm.type==1){
							copyFarmYearTask(this.$route.params.id,this.partition_id,this.year,this.importForm).then(resp => {
								 this.getFarmYearTask(this.year)
								this.importShow = false
							}).catch(error => console.log(error))
						}
						 if(this.importForm.type==2){
						 	copyFarmWorkTask(this.$route.params.id,this.partition_id,this.year,this.importForm).then(resp => {
						 		 this.getFarmYearTask(this.year)
						 		this.importShow = false
						 	}).catch(error => console.log(error))
						 }
					} else {
						console.log('error submit!!');
						return false;
					}
				});
                
            },
            // 导入年计划弹窗取消
            importCanse(){
                this.importShow = false
            },
            // 导入年计划判断，如果还没有历史记录弹窗确认
            importConfirmSave1(){
                this.importConfirmShow1 = false
            },
            // 导入年计划判断，如果还没有历史记录弹窗取消
            importConfirmCanse1(){
                this.importConfirmShow1 = false
            },
            // 判断，如果今年和明年的年计划都 有了，点击导入按钮时出现如上提示！弹窗确认
            importConfirmSave2(){
                this.importConfirmShow2 = false
            },
            // 判断，如果今年和明年的年计划都 有了，点击导入按钮时出现如上提示！弹窗取消
            importConfirmCanse2(){
                this.importConfirmShow2 = false
            },
            // 一键年计划弹窗确认
            onekeySave(){
				this.$refs["oneForm"].validate((valid) => {
					if (valid) {	
				makeFarmYearPlan(this.$route.params.id,this.partition_id,this.year,this.oneForm.type).then(resp=>{
					this.getFarmYearTask(this.year)
					this.$message.success(resp)
					this.onekeyShow = false
				})
				}
				})
                
            },
            // 一键年计划弹窗取消
            onekeyCanse(){
                this.onekeyShow = false
            },
            // 一键年计划判断弹窗确认
            onekeyConfirmSave(){
                this.onekeyConfirmShow = false
            },
            // 一键年计划判断弹窗取消
            onekeyConfirmCanse(){
                this.onekeyConfirmShow = false
            },
            // 删除弹窗确认
            delSave(){
                this.delShow = false
            },
            // 删除弹窗取消
            delCanse(){
                this.delShow = false
            },
            // 添加任务弹窗确认
            addTaskSave(){			
				this.$refs["taskForm"].validate((valid) => {
					if (valid) {			          
						 addFarmYearTask(this.$route.params.id,this.partition_id,this.year,this.taskForm).then(resp => {
							 this.getFarmYearTask(this.year)
							 this.addTaskShow = false
							this.clearTaskForm()
						}).catch(error => console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
               
            },
            // 添加任务弹窗取消
            addTaskCanse(){
				this.clearTaskForm()
                this.addTaskShow = false
            },
			clearTaskForm(){
				 this.taskForm["type_id"]='';
				  this.taskForm["data_task_id"]='';
				   this.taskForm["display_run_time"]='';
			},
            // 点击年预算编辑
            editBudget(value,unit){
				this.budget_value=value
                this.editUnit = unit
                this.editBudgetShow = true
            },
            // 年预算编辑弹窗确认
            editBudgetSave(){
				this.$refs["budgetForm"].validate((valid) => {
					if (valid) {	
						if(this.budget_value==5){
							this.fee_list.forEach((item, index) =>{
								   if(item.value==5){
									   this.fee_list[index]["number"]=this.budgetForm.budget
								   }
								 
							 })
						}else{
							this.est_list.forEach((item, index) =>{
								   if(item.value==this.budget_value){
									   this.est_list[index]["number"]=this.budgetForm.budget
								   }
								 
							 })
						}
						
						console.log(this.fee_list)
						this.budgetForm['budget']=0
						 this.editBudgetShow = false
					} else {
						console.log('error submit!!');
						return false;
					}
				});
               
            },
            // 年预算编辑弹窗取消
            editBudgetCanse(){
                this.editBudgetShow = false
            },
            // 编辑计划
            editPlan(id){
			
                this.$router.push('/park/farming/editPlan/'+this.$route.params.id+'/'+id);
            },
			deletePlan(id){
				 deleteFarmTask("delete_year_task",id).then(resp=>{
					 this.$message.success("操作成功")
					 this.getFarmYearTask(this.year)
				 })
				 
			}
        },
        components: {
            WxMessageBox
        }
    }
</script>

<style lang="less">
    .annualPlan{
        .select_year{
            margin-top: 25px;
            display: flex;
            align-items: center;
            .label{
                width: 99px;
                font-size: 16px;
                color: #91AFBA;
            }
            .el-input__inner{
                text-align: center;
            }
        }
        .tabs{
            display: flex;
            margin-top: 23px;
            span{
                width: 150px;
                height: 30px;
                border: 1px solid #2B92F6;
                line-height: 30px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                cursor: pointer;
            }
            .active{
                background: #2B92F6;
                color: #fff;
            }
        }
        .content{
            .title{
                width: 100%;
                font-size: 18px;
                font-weight: 400;
                color: #fff;
                text-align: center;
                margin-top: 35px;
                position: relative;
                span{
                    &+span{
                        padding-left: 10px;
                    }
                }
                .top_btn{
                    position: absolute;
                    right: 0;
                    top: 0;
                    .el-button{
                        padding: 7px 22px;
                        font-size: 18px;
                        font-weight: 400;
                        color: #fff;
                        background: #00A1E6;
                        border: 0;
                        border-radius: 0;
                    }
                }
            }
            .steps{
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 35px;
                .step{
                    width: 140px;
                    height: 140px;
                    line-height: 140px;
                    background: #00407D;
                    border-radius: 70px;
                    font-size: 20px;
                    font-weight: bold;
                    color: #B9B9B9;
                    text-align: center;
                    position: relative;
                    &+.step{
                        margin-left: 128px;
                    }
                }
                img{
                    width: 40px;
                    height: 40px;
                    margin: 0 45px;
                }
                .active{
                    background: #2D99FF;
                    color: #fff;
                }
            }
            .tabTop{
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .select_box{
                    .el-select{
                        width: 160px;
                        &+.el-select{
                            /*margin-left: 20px;*/
                        }
                    }
                }
                .btn_box{
                    .el-button{
                        width: 134px;
                        height: 40px;
                        line-height: 40px;
                        border: 1px solid #2D99FF;
                        font-size: 18px;
                        font-weight: 400;
                        color: #2D99FF;
                        background: transparent;
                        border-radius: 0;
                        padding: 0;
                    }
                }
            }
            .wx_table{
                margin-top: 25px;
            }
            .bottom_btn{
                margin-top: 50px;
                width: 100%;
                text-align: center;
                .el-button{
                    width: 310px;
                    height: 48px;
                    line-height: 48px;
                    background: #2D99FF;
                    font-size: 18px;
                    font-weight: 400;
                    color: #fff;
                    padding: 0;
                    border: 0;
                    border-radius: 0;
                }
            }
            .tabTitle{
                font-size: 18px;
                font-weight: 800;
                color: #FFFFFF;
            }
            .marTop{
                margin-top: 40px;
            }
        }
    }
</style>
